import React, { lazy } from 'react';

import type { ArticleContentProps } from './article-content';

const ArticleContentLazy = React.lazy(() =>
	import('./article-content').then((module) => ({ default: module.ArticleContent }))
);

export const ArticleContentClient = (props: ArticleContentProps) => {
	const isSSR = typeof window === 'undefined';

	return (
		<>
			{!isSSR && (
				<React.Suspense fallback={<div />}>
					<ArticleContentLazy {...props} fieldsKey={(target) => target?.fields} />
				</React.Suspense>
			)}
		</>
	);
};
